import { toPng, toJpeg } from 'html-to-image'
import { waitForImages } from '../catalogUrl'

export async function exportElementAsImage(
  element: HTMLElement,
  format: 'png' | 'jpg',
  width: number,
  height: number
): Promise<string> {
  await waitForImages(element)
  const options = {
    width,
    height,
    pixelRatio: 1,
    cacheBust: true,
    style: { transform: 'scale(1)', transformOrigin: 'top left' },
  }
  if (format === 'png') {
    return toPng(element, options)
  }
  return toJpeg(element, { ...options, quality: 0.92 })
}

export function downloadDataUrl(dataUrl: string, filename: string) {
  const link = document.createElement('a')
  link.href = dataUrl
  link.download = filename
  link.click()
}

export async function copyText(text: string) {
  await navigator.clipboard.writeText(text)
}

export async function shareWithWebApi(options: {
  title?: string
  text?: string
  files?: File[]
  url?: string
}): Promise<boolean> {
  if (!navigator.share) return false
  try {
    const shareData: ShareData = {
      title: options.title,
      text: options.text,
      url: options.url,
    }
    if (options.files?.length && navigator.canShare?.({ files: options.files })) {
      await navigator.share({ ...shareData, files: options.files })
    } else {
      await navigator.share(shareData)
    }
    return true
  } catch (err) {
    if ((err as Error).name === 'AbortError') return true
    return false
  }
}

export async function dataUrlToFile(dataUrl: string, filename: string): Promise<File> {
  const res = await fetch(dataUrl)
  const blob = await res.blob()
  return new File([blob], filename, { type: blob.type })
}
